import SubHeaderBox from "../NewCompany/CompanyDetail/components/SubHeaderBox";
import CompanySummary from "./CompanySummary";
import yfsLabelIcon from "../../assets/new-product-detail-cats/yfs-label/yfs-prod-bg.svg";
import { useTranslation } from "react-i18next";

const YFSLabelCompanyDetail = ({ companyData }) => {
  const { t } = useTranslation();
  return (
    <div className="yfs-prod-detail" id="yfs-label-id">
      <div style={{ display: "flex", gap: "13.24px", marginBottom: "38px" }}>
        <img src={yfsLabelIcon} alt="YFS Label Icon" width={74} height={75} />
        <SubHeaderBox
          subTitle={"YFS label"}
          subDescription={t("YFS_label_company_desc")}
          customStyle={{
            padding: "30px 30px 55px 30px",
          }}
        />
      </div>

      <CompanySummary companyData={companyData} editMode={false} />
    </div>
  );
};

export default YFSLabelCompanyDetail;
